import { CreateOrganizationDto, UpdateOrganizationDto } from '@taxora-api';

export class GetOrganizationById {
  static readonly type = '[OrganizationState] GetOrganizationById';
  constructor(public organizationId: number) {}
}

export class CreateOrganization {
  static readonly type = '[OrganizationState] CreateOrganization';
  constructor(public payload: CreateOrganizationDto) {}
}

export class UpdateOrganization {
  static readonly type = '[OrganizationState] UpdateOrganization';
  constructor(
    public organizationId: number,
    public payload: UpdateOrganizationDto,
  ) {}
}

export class SearchOrganizationByCui {
  static readonly type = '[OrganizationState] SearchOrganizationByCui';
  constructor(public cui: number) {}
}

export class ClearSearchedOrganization {
  static readonly type = '[OrganizationState] ClearSearchedOrganization';
}

export class GetCompanyTypes {
  static readonly type = '[OrganizationState] GetCompanyTypes';
}
